<template>
    <div class="jom-keyword" id="keyword">
      <h2 v-if="lang == 'zh' && keyword.length > 0">关键词</h2>
      <h2 v-else-if="keyword.length > 0">Keywords</h2>
      <p v-for="item in keyword" v-if="item.lang == lang">
        <a v-if="showLink" v-for="(item2,index) in item.data" target="_blank" :id="'kwd'+index" :href="'https://xueshu.baidu.com/s?wd='+getKeyText(item2,index)">
          <component :is="'jo' + item3.name" v-for="item3 in item2" v-bind:key="item3.index" v-bind:data="item3.data"></component>{{index!=(item.data.length-1)?';':''}}
        </a>
        <span v-if="!showLink" v-for="(item2,index) in item.data" :id="'kwd'+index">
          <component :is="'jo' + item3.name" v-for="item3 in item2" v-bind:key="item3.index" v-bind:data="item3.data"></component>{{index!=(item.data.length-1)?';':''}}
        </span>
      </p>
    </div>
</template>

<script>
  import joinlineformula from '../formula/inlineformula.vue'
    export default {
      components: {
        joinlineformula
      },
      data() {
          return {
            lang: this.ARTICLE.defaultlang,
            keyword: []
          }
      },
      props : [
        'language'
      ],
      created() {
          this.keyword = this.ARTICLE.keyword
          if (this.language !== undefined && this.language !== '') {
            this.lang = this.language;
          }
      },
      mounted() {
        if (this.layout !== 'rc'){
          this.$bus.on('currentLang', (lang) => {
            this.lang = lang;
          })
        }
      },
      methods: {
        getKeyText(keyItem,index1) {
          let keyText = "";
          keyItem.forEach((item, index) => {
            if (item.name == "inlineformula") {
              /*item.data.forEach((mathItem, mathIndex) => {
                if (mathItem.data && mathItem.data.math) {
                  keyText += mathItem.data.math
                }
              })*/
              this.$nextTick(function () {
                let kwdDom = document.getElementById('kwd'+index1);
                kwdDom.setAttribute('href','https://xueshu.baidu.com/s?wd='+kwdDom.innerText)
              })
            } else if(item.name === "text"){
              keyText += item.data;
            }
            else {
              keyText += this.getKeyText(item.data)
            }
          });
          return keyText;
        }
      }
    }
</script>
<style lang="scss" scoped>
    .jom-keyword{
      h2{
        background: none;
        color: #333;
      }
      a{
        color:#00a2af;
      }
    }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/keyword/keyword.vue